

export const getDefaultSettingItems = () => {
    return [
        {
            name: "Excellent",
            position: 0,
            maxRange: 100,
            minRange: 90,
            color: "#00B050"
        },
        {
            name: "Good",
            position: 1,
            maxRange: 89,
            minRange: 80,
            color: "#00B0F0"
        },
        {
            name: "Average",
            position: 2,
            maxRange: 79,
            minRange: 70,
            color: "#FFFF00"
        },
        {
            name: "Sufficient",
            position: 3,
            maxRange: 69,
            minRange: 60,
            color: "#FFC000"
        },
        {
            name: "Bad",
            position: 4,
            maxRange: 59,
            minRange: 0,
            color: "#156082"
        }
    ]
}

export const cleanSettingItems = (settingItems) => {
    return settingItems.map((item, index) => {
        delete item.__typename
        if (item.position === undefined) {
            item.position = index;
        }
        return item
    })
}

export const cleanSectionsItems = (sections) => {
    return sections.map(s => {
        s.evaluationItems.map(e => {
            delete e.__typename
            return e
        })
        delete s.__typename
        return s
    })
}